var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-empty-content"},[_c('img',{attrs:{"src":require("../images/data_empty.png"),"alt":""}}),_c('p',[_vm._v("暂无数据~")])])
}]

export { render, staticRenderFns }